import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden mb-4 text-2xl font-bold text-ellipsis lg:mb-6 lg:text-4xl" }


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(__props.title), 1))
}
}

})